import React, { useCallback } from 'react'
import { CircularProgress, useTheme } from '@material-ui/core'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import messages from '../../../../../services/messages'

import {
  ChevronRightRounded as ArrowRightIcon,
  StarBorder as StarIcon,
  FileCopyRounded as FileIcon,
  Star as StarFull,
} from '@material-ui/icons'

import {
  favoriteScript,
  favoritedScript,
  favoriteError,
} from '../../../../../redux/favoriteScript/actions'

import useStyles from '../style'
import Typography from '../../../../atoms/display/typography'
import HighlightSearch from '../../../../atoms/display/highlightSearch'
import { setScriptDescription } from '../../../../../redux/script/actions'

function ScriptChildAccordion({
  key,
  subkey,
  category,
  scriptChild,
  remove,
  ...props
}) {
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const { status } = useSelector((state) => state.favoriteScripts)
  const activeConversation = useSelector((state) => state.activeConversation)
  const keyword = useSelector(
    (state) => state.faq?.keyword?.[activeConversation]
  )

  const setScriptsFavorites = async (scriptId) => {
    dispatch(favoriteScript(scriptId, remove))
    try {
      const response = await messages.patch(
        `/tech4h-messages/script/favorite/${scriptId}`,
        { remove: remove }
      )

      if (response.status === 200) {
        dispatch(
          favoritedScript({
            favoriteScript: response.data.data.favorite_messages,
            scriptId: null,
          })
        )
      } else {
        throw response.data
      }
    } catch (error) {
      console.log(error)
      const message =
        error?.response?.status === 500
          ? 'Unavailable service'
          : error?.response?.data?.message
      enqueueSnackbar(t('toasts.actionError'), {
        variant: 'error',
      })
      dispatch(favoriteError({ action: 'favorited_script', message: message }))
    }
  }
  const renderStar = useCallback(() => {
    if (
      status?.loading &&
      status?.scriptId === scriptChild?.id &&
      status?.error !== true
    ) {
      return <CircularProgress size={24} />
    }
    if (remove) {
      return (
        <StarFull
          onClick={() => {
            setScriptsFavorites(scriptChild?.id)
          }}
          style={{ marginLeft: '0.2em' }}
          className={classes.cursorIcon}
        ></StarFull>
      )
    } else {
      return (
        <StarIcon
          onClick={() => {
            setScriptsFavorites(scriptChild?.id)
          }}
          style={{ marginLeft: '0.2em' }}
          className={classes.cursorIcon}
        ></StarIcon>
      )
    }
  }, [status, scriptChild, remove])

  return (
    <div className={classes.hoverContainerChildAccordion}>
      <div className={classes.descriptionContainer} key={key + subkey}>
        <div
          className={classes.shortcutContent + ' search-anchor-tree'}
          style={{ marginTop: 0 }}
          onClick={() => {
            dispatch(setScriptDescription(activeConversation, scriptChild))
          }}
        >
          <Typography
            style={{
              color:
                theme.palette.type === 'dark' ? '#fff' : 'rgba(28,48,89,1)',
              maxWidth: '330px',
              wordBreak: 'break-all',
            }}
          >
            <HighlightSearch
              text={scriptChild.title}
              keyword={keyword}
              anchor="faq"
              copy={false}
            />
          </Typography>
        </div>
        <div
          style={{
            justifyContent: 'flex-end',
            width: '100px',
            marginRight: '0.25em',
            display: 'flex',
          }}
        >
          {scriptChild?.files && (
            <FileIcon
              className={classes.cursorIcon}
              onClick={() => window.open(scriptChild?.files)}
            ></FileIcon>
          )}
          {renderStar(remove)}
          <ArrowRightIcon
            onClick={() => {
              setEnterDescription(scriptChild)
            }}
            className={classes.cursorIcon}
          ></ArrowRightIcon>
        </div>
      </div>
      {!!subkey && (
        <hr className={classes.scriptDivider} style={{ opacity: 0.5 }}></hr>
      )}
    </div>
  )
}

export default ScriptChildAccordion
